import Vue from 'vue';
import Buefy from 'buefy';
import VueScreen from 'vue-screen';
import App from './App.vue';
import router from './router';
import store from './store';
import 'buefy/dist/buefy.css';
import 'leaflet/dist/leaflet.css';
import './plugins/vee-validate';
import i18n from './plugins/i18n';
import './styles/styles.scss';
import CustomIcon from './components/UI/CustomIcon.vue';
import { initFirebase } from './push-notification';
import workbox from './registerServiceWorker';

Vue.prototype.$workbox = workbox.wb;

Vue.component('custom-icon', CustomIcon);

Vue.use(Buefy, {
  defaultIconComponent: 'custom-icon',
  defaultIconPack: 'mdi',
  customIconPacks: {
    mdi: {
      iconPrefix: '',
      sizes: {
        default: 24,
        'is-small': 16,
        'is-medium': 32,
        'is-large': 40,
      },
    },
  },
});

Vue.use(VueScreen);

Vue.config.productionTip = false;

initFirebase();
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
